import { PdfDownloadButton } from '@/components';
import { specialRequestsHttp } from '@/core';
import { ButtonType } from 'antd/lib/button';
import { useCallback } from 'react';

interface Props {
  specialRequestId: string;
  type?: ButtonType;
  onlyIcon?: boolean;
}

function useDownloadPdf(id: string) {
  return useCallback(async () => {
    return await specialRequestsHttp.downloadPdf(id);
  }, [id]);
}

export const SpecialRequestPdfDownloadButton = (props: Props) => {
  const { specialRequestId, type, onlyIcon } = props;
  const downloadPdf = useDownloadPdf(specialRequestId);
  return (
    <PdfDownloadButton action={downloadPdf} onlyIcon={onlyIcon} type={type} />
  );
};
